var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProflie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 682.67 682.67",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 682.67)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(497,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-133.1-107.9-241-241-241-133.1 0-241 107.9-241 241 0 133.1 107.9 241 241 241 133.1 0 241-107.9 241-241z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.4 288.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-53.24-43.158-96.4-96.4-96.4-53.244 0-96.401 43.16-96.401 96.4 0 53.239 43.157 96.399 96.401 96.399 53.242 0 96.4-43.16 96.4-96.399z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.21 62.575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c7.71 72.602 69.142 129.16 143.79 129.16 74.647 0 136.08-56.56 143.78-129.16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProflie);
export default __webpack_public_path__ + "static/media/proflie.9c9f15390ddab15490bf4dcd0fbeb629.svg";
export { ForwardRef as ReactComponent };